<template>
	<CritereRechercheSuivi ref="critereRechercheSuivi" :criteresRecherche="rechercheHistorique"
													@rechercher="rechercher" @effacerCriteres="effacerCriteres" @fermer="fermer"/>
	<ResultatSuivi :suivis="suivis" :isRechercheDataLoading="isRechercheDataLoading" />
</template>

<script>
import CritereRechercheSuivi from '../../../components/dossier/Rechercher/CritereRechercheSuivi.vue'
import ResultatSuivi from '../../../components/dossier/Rechercher/ResultatSuivi.vue'
import axios from 'axios'
import {mapGetters} from 'vuex'


export default {
	name: "RechercherSuivi",
	components: {
		CritereRechercheSuivi,
		ResultatSuivi
	},
	mounted(){

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
		this.isRechercheDataLoading = true;
		this.$root.$refs.breadcrumbComp.ajout("Recherche de Suivis");
		if (this.rechercheHistorique) {
			this.rechercher(this.rechercheHistorique);
		} else {
			this.$store.dispatch('suivi/rechercherDefaut48HeuresSuivisAction')
					.then((res) => {
						this.assignerResultat(res)
						this.isRechercheDataLoading = false;
					});
		}
	},
	data(){
		return {
			isRechercheDataLoading: false,
			suivis: [],
		}
	},
	computed: {
		...mapGetters({
			jeton: 'cardex/jeton',
      profil: 'cardex/profil',
			rechercheHistorique: 'suivi/rechercheHistorique',
		})
	},
	methods: {	
		rechercher(critereRechercheSuivi) {
			this.isRechercheDataLoading = true;
			this.$store.dispatch('suivi/rechercherSuivisAction', critereRechercheSuivi)
			.then((res) => {
				this.$store.commit('suivi/AJOUT_RECHERCHE_HISTORIQUE', critereRechercheSuivi)
				this.assignerResultat(res)
				this.isRechercheDataLoading = false;
			})
		},
		assignerResultat(res){
			this.suivis = res.data.entites;
			this.$root.$refs.messagesComp.messagesList = res.data.messages
			this.$refs.critereRechercheSuivi.assignerListe(res.data.entiteDecision);
		},
		effacerCriteres() {
			this.isRechercheDataLoading = true;		
			this.$store.dispatch('suivi/rechercherDefaut48HeuresSuivisAction')
			.then((res) => {
				this.assignerResultat(res)
				this.isRechercheDataLoading = false;
			})
		},
		fermer() {
			this.$root.$refs.breadcrumbComp.menu();
		}, 			
	}
}
</script>